import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToSlug',
  standalone: true,
})
export class ConvertToSlugPipe implements PipeTransform {
  transform(text?: string): string {
    if (!text) return '';

    return text
      .normalize('NFD') // Normaliser les caractères accentués (é -> e + ´)
      .replace(/[\u0300-\u036f]/g, '') // Supprimer les diacritiques (accents)
      .toLowerCase() // Convertir en minuscules
      .replace(/[^a-z0-9\s,.-]/g, '') // Supprimer les caractères non désirés (sauf chiffres, %, virgule, point, tiret)
      .replace(/,/g, '-') // Remplacer les virgules par des tirets
      .replace(/\./g, '-') // Remplacer les points par des tirets
      .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
      .replace(/-+/g, '-') // Remplacer les tirets multiples par un seul tiret
      .replace(/^-+/, '') // Supprimer les tirets en début de chaîne
      .replace(/-+$/, ''); // Supprimer les tirets en fin de chaîne
  }
}